




import TariffZones from "../Tarification/TariffZones.vue";
import { Component, Vue } from "vue-property-decorator";
import { TarificationTypes, TarificationTransports } from "@/store/tarification/types";

@Component({ components: { TariffZones } })
export default class CallPartnerTariffZones extends Vue {
  private partnerType: TarificationTypes = TarificationTypes.PARTNER;
  private tarificationTransport: TarificationTransports = TarificationTransports.CALL;
}
